



































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { tickets, user } from '@/modules/shared/shared/store/namespaces';
import { IS_EMPLOYEE } from '@/modules/users/store/user.getters';
import { getFullDate, getDate } from '@/modules/shared/shared/domain/functions/date-functions';
import {
    Statuses,
    AccessMotives,
    MovementType,
} from '@/modules/shared/shared/domain/constants/constants';

@Component
export default class PDTDescription extends Vue {
    AWAITING_MODIFICATION_STATUS: number = Statuses.AWAITING_MODIFICATION.id;

    get attachments() {
        return [
            {
                text: 'PERMISO-DE-ACCESO.pdf',
                link: `tickets/access/modify/${this.ticketDetail.id}`,
                show: true,
            },
            {
                text: 'MOVIMIENTO-DE-EQUIPOS.pdf',
                link: 'equipment-sheet',
                show: this.requiresEquipmentSheet(),
            },
        ];
    }

    requiresEquipmentSheet() {
        return this.ticketDetail.accessPermission.accessPermissionEquipments.find(i =>
            i.movementType.id === MovementType.DEPARTURE ? true : false,
        );
    }

    get attachmentsToShow() {
        return this.attachments.filter(i => i.show);
    }

    // Returns date with the format: martes, 12 de abril de 2020
    setFormatDate(dateWithTimezone: string): string {
        return getFullDate(dateWithTimezone);
    }

    redirectTo(fileName: string) {
        if (fileName === 'PERMISO-DE-ACCESO.pdf') {
            let to = { name: 'pdt' };
            let routeData = this.$router.resolve(to);
            window.open(routeData.href, '_blank');
        } else if (fileName === 'MOVIMIENTO-DE-EQUIPOS.pdf') {
            let to = { name: 'equipment-sheet' };
            let routeData = this.$router.resolve(to);
            window.open(routeData.href, '_blank');
        }
    }

    // TODO: Esta función está replicada acá y en el dashboard de Permisos de Acceso al DC.
    // Centralizar esta función en un archivo común para ambos
    getAccessMotives(
        accessPermissionMotives: {
            accessMotiveDescription?: string;
            accessPermissionTypeMotive: {
                id: number;
                accessMotive: {
                    id: number;
                    name: string;
                };
            };
        }[],
    ): string {
        let accessMotives: string = '';

        accessPermissionMotives.forEach((element, index) => {
            if (element.accessPermissionTypeMotive.accessMotive) {
                //if (index === 0) {
                // first element
                accessMotives += `${element.accessPermissionTypeMotive.accessMotive.name}`;
                //} else {
                //    accessMotives += `${element.accessPermissionTypeMotive.accessMotive.name.toLowerCase()}`;
                //}

                if (
                    element.accessPermissionTypeMotive.accessMotive.id ===
                    AccessMotives.ANOTHER_MOTIVE.id
                ) {
                    accessMotives += `: ${element.accessMotiveDescription}`;
                }
            }
            if (index + 1 < accessPermissionMotives.length) {
                accessMotives += ', ';
            }
        });
        //remover duplicados
        let uniqueAccessMotives = accessMotives.split(', ');
        uniqueAccessMotives = [...new Set(uniqueAccessMotives)];
        accessMotives = '';
        uniqueAccessMotives.forEach((uniqueMotive, index) => {
            accessMotives += index == 0 ? uniqueMotive : uniqueMotive.toLowerCase();
            accessMotives += ', ';
        });
        return accessMotives.slice(0, -2);
    }

    getAccessType(
        accessPermissionMotives: {
            accessMotiveDescription?: string;
            accessPermissionTypeMotive: {
                id: number;
                accessMotive: {
                    id: number;
                    name: string;
                };
                accessType: {
                    id: number;
                    name: string;
                };
            };
        }[],
    ): string {
        let reasons = new Set();
        accessPermissionMotives.forEach(motive => {
            if (motive.accessPermissionTypeMotive) {
                reasons.add(motive.accessPermissionTypeMotive.accessType.name);
            }
        });
        let reasonsString = '';
        let index = 0;
        if (reasons.size > 0) {
            reasons.forEach(reason => {
                reasonsString += index == 0 ? reason : (reason as string).toLowerCase();
                reasonsString += ', ';
                index++;
            });
            return reasonsString.slice(0, -2);
        } else {
            return '';
        }
    }

    @tickets.State('ticketDetail') ticketDetail;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
}
